const KEYWORD = "hak";
export default {
  setHak(value) {
    localStorage.setItem(KEYWORD, value);
  },
  getHak() {
    return localStorage.getItem(KEYWORD);
  },
  removeHak() {
    localStorage.removeItem(KEYWORD);
  }
};
